import React from "react";
import News from "./index";

const NewsIndex = () => {
  return <News />;
};

export default NewsIndex;
